import PublicLayout from '@/components/layout/PublicLayout';
import { impressumContent } from '@/content/legal/impressum';

export default function ImpressumPage() {
  return (
    <PublicLayout>
      <div className="max-w-4xl mx-auto">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700 p-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-8">
            {impressumContent.title}
          </h1>

          <div className="space-y-8">
            {impressumContent.sections.map((section, index) => (
              <div key={index}>
                {section.title !== null && section.title !== undefined && (
                  <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                    {section.title}
                  </h2>
                )}
                <div className="space-y-2">
                  {section.content.map((paragraph, pIndex) => (
                    <p
                      key={pIndex}
                      className="text-gray-700 dark:text-gray-300 leading-relaxed"
                    >
                      {paragraph}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </PublicLayout>
  );
}
